import { Text } from '@foss/legion-ui'
import { findItem } from '../nav/registry'
import { seedFor } from '../examples/seeds'
import { PropsTable } from '../content/PropsTable'
import { Workspace } from '../workspace/Workspace'
import { CodeBlock } from '../content/CodeBlock'
import prose from '../content/Prose.module.css'

export function ComponentPage({ slug }: { slug: string }) {
  const entry = findItem(slug)
  if (!entry) {
    return (
      <Text tone="muted" data-testid="not-found">
        No page at this address.
      </Text>
    )
  }

  const name = entry.item.name
  const seed = seedFor(slug)

  return (
    <div data-testid={`component-page-${slug}`}>
      <CodeBlock label="import">
        {`import { ${name} } from '@foss/legion-ui'`}
      </CodeBlock>

      {seed ? (
        <section className={prose.section}>
          <Text variant="heading" as="h2">
            Example
          </Text>
          <Workspace name={name} source={seed} />
        </section>
      ) : (
        <Text tone="muted" data-testid="placeholder">
          A live example for {name} is on its way.
        </Text>
      )}

      <section className={prose.section}>
        <Text variant="heading" as="h2">
          Props
        </Text>
        <PropsTable component={name} />
      </section>
    </div>
  )
}
